import { render } from "./HostedHouseListComponent.vue?vue&type=template&id=0611b9fa&ts=true"
import script from "./HostedHouseListComponent.vue?vue&type=script&lang=ts"
export * from "./HostedHouseListComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__